import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import Toast from "react-native-toast-notifications";
import BaseToast from "./variations/BaseToast";
const ToastInstance = forwardRef(({ offsetTop = 0, placement = "top", offsetBottom = 5, duration = 3000 }, ref) => {
    return (_jsx(Toast, { ref: ref, placement: placement, duration: duration, animationType: "slide-in", animationDuration: 250, offsetTop: offsetTop, offsetBottom: offsetBottom, swipeEnabled: true, renderToast: (toastProps) => _jsx(BaseToast, { ...toastProps }) }));
});
export default ToastInstance;
